import moment from 'moment';
import i18n from '@/i18n';

export default function (value) {
  // moment.locale('pt-BR');
  moment.locale(i18n.locale);
  return moment(value).fromNow();
}
